var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,{tag:"component",attrs:{"size":_vm.size,"colors":_vm.colors}})
}
var staticRenderFns = []

export { render, staticRenderFns }